import { VStack } from '@genial/components';
import React from 'react';

import { CustomerListLoadingItem } from '../CustomerListLoadingItem';

interface CustomerListLoadingProps {
  quantity?: number;
}

const CustomerListLoading: React.FC<CustomerListLoadingProps> = ({ quantity = 1 }) => {
  return (
    <VStack space="stack.nano">
      {[...Array(quantity)].map((_, index) => (
        <CustomerListLoadingItem key={index} />
      ))}
    </VStack>
  );
};

export const CustomerListLoadingMemoized = React.memo(CustomerListLoading);
